import { Button } from '~/legacy-components/ui/button';
import { Model } from '~/services/models.types';

import { ArrowRightIcon } from '@radix-ui/react-icons';

export function EmptyLLMOutput({
  setInput,
  model,
  apiMode,
}: {
  setInput?: (input: string) => void;
  model?: Model;
  apiMode: 'chat' | 'completion';
}) {
  return (
    <div className="max-w-2xl px-4">
      <div className="bg-background rounded-lg border p-8">
        <h1 className="mb-2 text-lg font-semibold">
          Try out {model?.title} (via our {apiMode} API)
        </h1>
        <p className="text-muted-foreground mb-2 leading-normal">
          Kick the tires and see how {model?.title} performs when deployed using Fireworks AI!
        </p>
        <div className="mt-4 flex flex-col items-start space-y-2">
          {/* @ts-expect-error: TODO */}
          {model?.examples?.map((message, index) => (
            <Button
              key={index}
              variant="link"
              className="h-auto p-0 text-base"
              onClick={() => setInput?.(message.prompt)}
            >
              <ArrowRightIcon className="text-muted-foreground mr-2" />
              {message.title}
            </Button>
          ))}
        </div>
      </div>
    </div>
  );
}
